import type { BrandingPublico } from '@postmaker/shared';
import { iniciarTema } from './tema.ts';

/** Marca blanca (D17): colores, nombre visible y favicon de la empresa en la propia UI. */
export function aplicarBranding(branding: Partial<BrandingPublico> | null): void {
  const raiz = document.documentElement;
  const colores: Record<string, string | undefined> = {
    '--color-primario-var': branding?.colorPrimario,
    '--color-acento-var': branding?.colorAcento,
  };

  for (const [variable, valor] of Object.entries(colores)) {
    if (valor) raiz.style.setProperty(variable, valor);
  }

  // Texto sobre el acento: negro si el acento es claro, blanco si es oscuro.
  const acento = branding?.colorAcento;
  if (acento && /^#[0-9a-fA-F]{6}$/.test(acento)) {
    const [r, g, b] = [1, 3, 5].map((i) => parseInt(acento.slice(i, i + 2), 16));
    const luz = (0.299 * r! + 0.587 * g! + 0.114 * b!) / 255;
    raiz.style.setProperty('--color-acento-texto', luz > 0.6 ? '#101113' : '#ffffff');
  }

  iniciarTema(branding?.modoOscuro);

  const nombre = branding?.nombreVisible;
  document.title = nombre ? `${nombre}` : 'Post Maker';

  const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
  if (meta && branding?.colorPrimario) meta.content = branding.colorPrimario;

  const favicon = document.getElementById('favicon');
  if (favicon instanceof HTMLLinkElement && branding?.faviconUrl) {
    favicon.href = branding.faviconUrl;
  }
}
